import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../shared/services/api/api.service';
import {
  BillLogTypeEnum,
  BillStatusEnum,
  IBillItem,
  IGetBilledListResponse,
  IGetNotBilledListResponse,
} from '../bills.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BillsService {
  constructor(private readonly apiService: ApiService, private readonly http: HttpClient) {}

  getNotBilledList(filters: {
    date?: Date | null;
    protocol?: string | null;
    paymentTypeId?: number | null;
    caseTypeId?: number | null;
    sortField: any;
    sortOrder: 'ASC' | 'DESC';
  }): Observable<IGetNotBilledListResponse> {
    return this.apiService.post<IGetNotBilledListResponse>(
      'bills/get-not-billed-list',
      {
        ...filters,
      }
    );
  }

  getBilledList(filters: {
    startDate: Date | null;
    endDate: Date | null;
    protocol: string | null;
    billNo: string | null;
    billStatus: BillStatusEnum | null;
    caseTypeId?: number | null;
    sortField?: any;
    sortOrder?: 'ASC' | 'DESC';
    first: number;
    rows: number;
  }): Observable<IGetBilledListResponse> {
    return this.apiService.post<IGetBilledListResponse>(
      'bills/get-billed-list',
      {
        ...filters,
      }
    );
  }

  sendElogo(billIds: number[], date: Date) {
    return this.apiService.post<{
      success: boolean;
      errorBills: { billId: number; error: string }[];
    }>('bills/send-eLogo', {
      billIds,
      date,
    });
  }

  sendElogoAgain(billId: number) {
    return this.apiService.post<{
      success: boolean;
      errorBills: { billId: number; error: string }[];
    }>('bills/send-eLogo-again', {
      billId,
    });
  }

  saveManuelBill(billIds: number[], date: Date, billNo: string) {
    return this.apiService.post<{ success: boolean }>(
      'bills/save-manuel-bill',
      {
        billIds,
        date,
        billNo,
      }
    );
  }

  saveBillPrintedFormSettings(serviceObj: {
    billId: number;
    services: any[];
    type: 'MULTI' | 'SINGLE';
  }) {
    return this.apiService.post<{ success: boolean; response: any }>(
      'bills/save-printed-form-settings',
      {
        ...serviceObj,
      }
    );
  }

  deletePrintedFormSettings(billId: number) {
    return this.apiService.delete<{ success: boolean }>(
      `bills/delete-printed-form-settings/${billId}`
    );
  }

  getBillLogs(billId: number, type?: BillLogTypeEnum[]) {
    return this.apiService.post<any[]>(`bills/get-bill-logs/`, {
      id: billId,
      type,
    });
  }

  getBillDocument(billId: number): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}bills/get-bill-document/${billId}`,
      {
        responseType: 'blob' as 'json',
        observe: 'response',
      }
    );
  }

  sendBillDocumentEmail(billId: number, emails: string[]) {
    return this.apiService.post<{ success: boolean; message: string }>(
      `bills/send-bill-document/`,
      {
        billId,
        emails,
      }
    );
  }

  cancelBill(
    billId: number,
    cancelDate: Date | null,
    description: string | null
  ) {
    return this.apiService.post<{ success: boolean; message: string }>(
      'bills/cancel-bill',
      {
        billId,
        cancelDate,
        description,
      }
    );
  }

  getBillsByCaseId(caseId: number) {
    return this.apiService.get<{ success: true; items: IBillItem[] }>(
      `bills/by-case/${caseId}`
    );
  }

  sendErp(billIds: number[]) {
    return this.apiService.post<{
      success: boolean;
      errorBills: { billId: number; error: string }[];
    }>(`bills/send-erp`, {
      billIds,
    });
  }
}
